import { Button } from "@/components/ui/button";
import moment from "moment";

export function MachineCmSotDetailHandler({
  currentExport,
  data,
  dataSave,
  exportToExcel,
}) {
  if (currentExport == "Machine CM SOT") {
    const exportData = dataSave.machines.map((machine) => {
      let totalCM = 0;
      let totalPRTOnCM = 0;

      let responseTime = 0;
      let coordinationTime = 0;
      let resolveTime = 0;
      let partSuspendedTime = 0;
      let engineerSuspendedTime = 0;
      let otherSuspensionTime = 0;

      machine.service_order_tickets
        .map((sot) => {
          if (data.month_year) {
            const year = data.month_year.split("-")[0];
            const month = data.month_year.split("-")[1];
            if (
              moment(sot.reported_date).format("YYYY") != year ||
              moment(sot.reported_date).format("MM") != month
            ) {
              return null;
            }
          }
          // total of CM SOT
          if (sot.service_type_name === "CORRECTIVE_MAINTENANCE") {
            totalCM = totalCM + 1;
            totalPRTOnCM =
              totalPRTOnCM +
              (sot.part_request_ticket?.length
                ? sot.part_request_ticket.length
                : 0);

            // Response Time
            const openTime = sot.status_work.find(
              (sw) => sw.status_work_code === "OPN",
            )?.created_at;
            const startTime = sot.status_work.find(
              (sw) => sw.status_work_code === "STR",
            )?.created_at;
            const sotResponseTime = startTime
              ? moment(startTime).diff(moment(openTime))
              : 0;
            responseTime = responseTime + sotResponseTime;

            // Coordination Time
            const appointmentTime = sot.status_work.find(
              (sw) => sw.status_work_code === "APN",
            )?.created_at;
            const departTime = sot.status_work.find(
              (sw) => sw.status_work_code === "DPT",
            )?.created_at;
            const sotCoordinationTime = departTime
              ? moment(departTime).diff(moment(appointmentTime))
              : 0;
            coordinationTime = coordinationTime + sotCoordinationTime;

            // Resolve Time
            const stopTime = sot.status_work.find(
              (sw) => sw.status_work_code === "STP",
            )?.created_at;
            const sotResolveTime = stopTime
              ? moment(stopTime).diff(moment(startTime))
              : 0;
            resolveTime = resolveTime + sotResolveTime;

            // Part Suspended Time
            let suspendedByPartKeys = [];
            sot.status_work
              .map((sw, index) => {
                if (sw.status_work_code === "SPP") {
                  suspendedByPartKeys.push(index);
                  return sw;
                }
              })
              .filter((sw) => sw != undefined);

            for (let i = 0; i < suspendedByPartKeys.length; i++) {
              const sppTime =
                sot.status_work[suspendedByPartKeys[i]]?.created_at;
              const afterSppTime =
                sot.status_work[suspendedByPartKeys[i] - 1]?.created_at;
              const sotSppTime = afterSppTime
                ? moment(afterSppTime).diff(moment(sppTime))
                : 0;
              partSuspendedTime = partSuspendedTime + sotSppTime;
            }

            // Engineer Suspended Time
            let suspendedByEngineerKeys = [];
            sot.status_work
              .map((sw, index) => {
                if (sw.status_work_code === "SPE") {
                  suspendedByEngineerKeys.push(index);
                  return sw;
                }
              })
              .filter((sw) => sw != undefined);

            for (let i = 0; i < suspendedByEngineerKeys.length; i++) {
              const speTime =
                sot.status_work[suspendedByEngineerKeys[i]]?.created_at;
              const afterSpeTime =
                sot.status_work[suspendedByEngineerKeys[i] - 1]?.created_at;
              const sotSpeTime = afterSpeTime
                ? moment(afterSpeTime).diff(moment(speTime))
                : 0;
              engineerSuspendedTime = engineerSuspendedTime + sotSpeTime;
            }

            // Other Suspended Time
            let suspendedByOtherKeys = [];
            sot.status_work
              .map((sw, index) => {
                if (sw.status_work_code === "SPO") {
                  suspendedByOtherKeys.push(index);
                  return sw;
                }
              })
              .filter((sw) => sw != undefined);

            for (let i = 0; i < suspendedByOtherKeys.length; i++) {
              const spoTime =
                sot.status_work[suspendedByOtherKeys[i]]?.created_at;
              const afterSpoTime =
                sot.status_work[suspendedByOtherKeys[i] - 1]?.created_at;
              const sotSpoTime = afterSpoTime
                ? moment(afterSpoTime).diff(moment(spoTime))
                : 0;
              otherSuspensionTime = otherSuspensionTime + sotSpoTime;
            }
          }
        })
        .filter((sot) => sot != null);

      const internalSuspendTime = partSuspendedTime + engineerSuspendedTime;
      const internalDowntime =
        responseTime + coordinationTime + resolveTime + internalSuspendTime;
      const externalDowntime = otherSuspensionTime;
      const machineDowntime = internalDowntime + externalDowntime;

      return {
        "WS ID": machine.alias,
        "Machine Loc": machine.location_name,
        "Customer Name": machine.customer.name,
        "SE Name": machine.mapping_area?.service_engineer?.user.name,
        "Total of CM SOT": totalCM,
        "Total of CM PRT": totalPRTOnCM,
        "Response Time": responseTime
          ? moment(responseTime).subtract(7, "hours").format("HH:mm:ss")
          : "-",
        "Coordination Time": coordinationTime
          ? moment(coordinationTime).subtract(7, "hours").format("HH:mm:ss")
          : "-",
        "Resolve Time": resolveTime
          ? moment(resolveTime).subtract(7, "hours").format("HH:mm:ss")
          : "-",
        "Part Suspended Time": partSuspendedTime
          ? moment(partSuspendedTime).subtract(7, "hours").format("HH:mm:ss")
          : "-",
        "Engineer Suspended Time": engineerSuspendedTime
          ? moment(engineerSuspendedTime)
              .subtract(7, "hours")
              .format("HH:mm:ss")
          : "-",
        "Other Suspended Time": otherSuspensionTime
          ? moment(otherSuspensionTime).subtract(7, "hours").format("HH:mm:ss")
          : "-",
        "Internal Suspended Time": moment(internalSuspendTime)
          .subtract(7, "hours")
          .format("HH:mm:ss"),
        "Internal Down Time": moment(internalDowntime)
          .subtract(7, "hours")
          .format("HH:mm:ss"),
        "External Down Time": moment(externalDowntime)
          .subtract(7, "hours")
          .format("HH:mm:ss"),
        "Machine Down Time": moment(machineDowntime)
          .subtract(7, "hours")
          .format("HH:mm:ss"),
      };
    });

    return (
      <Button
        variant="primary"
        onClick={() =>
          exportToExcel(
            exportData,
            `machine_cm_sot_${moment().format("hhmm_DDMMYYYY")}.xlsx`,
          )
        }
      >
        Submit
      </Button>
    );
  }
  return null;
}
